<template>
  <div>
    <div class="row">
      <div class="col-lg-12 add-form">
        <input class="form-control datatable_search" @keyup="searchDatatable" placeholder="Search..." />
      </div>
    </div>
    <table class="dataTable table">
      <thead>
        <tr>
          <th v-for="field in fields" :key="field.key">{{ field.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td
            v-for="field in fields" :key="field.key"
            :class="{'checkbox-icon pt-0 disabled-click': field.key === 'is_enabled'}">
            <label class="checkbox-container" v-if="field.key === 'is_enabled'">
              <input :checked="!(item.is_enabled === 0 || item.is_enabled === '0')" type="checkbox">
              <span class="checkmark"></span>
            </label>
            <span v-else-if="field.link">
              <router-link :to="{ name: field.link.name, params: { id: item.id } }">{{ item[field.key] }}</router-link>
            </span>
            <span v-else-if="field.key === 'action'">
              <i class="fa fa-trash fa-icons" @click="field.actions.remove(item.id)" aria-hidden="true"></i>
              <router-link :to="{
                name: field.actions.edit.name,
                params: { ...field.actions.edit.params, id: item.id } }
              ">
                <i class="fas fa-pencil-alt fa-icons ml-md-1"></i>
              </router-link>
            </span>
            <span v-else>{{ item[field.key] }}</span>
          </td>
        </tr>
      </tbody>
      <tfoot></tfoot>
    </table>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  name: 'Datatable',
  props: {
    items: { required: true, type: Array },
    fields: { required: true, type: Array }
  },
  data () {
    return {
      datatable: null
    }
  },
  mounted () {
    setTimeout(() => this.initDatatables(), 100)
  },
  methods: {
    searchDatatable (e) {
      this.datatable.search(e.target.value).draw()
    },
    initDatatables () {
      this.datatable = $('table').DataTable({
        destroy: true,
        stateSave: true,
        pagingType: 'full_numbers',
        columnDefs: [{
          targets: 5,
          'orderable': false
        },
        {
          type: 'natural',
          targets: 1
        }
        ],
        stateSaveCallback: function (settings, data) {
          localStorage.setItem('DataTables_accounts_page', JSON.stringify(data))
        },
        stateLoadCallback: function (settings) {
          return JSON.parse(localStorage.getItem('DataTables_accounts_page'))
        },
        drawCallback: function (settings) {
          $('.previous').html("<img src='/static/images/left_arrow.svg'>")
          $('.next').html("<img src='/static/images/right_arrow.svg'>")
          $('.first').addClass('d-inline')
          $('.first').html("<img src='/static/images/left_arrow.svg'><img src='/static/images/left_arrow.svg'>")
          $('.last').addClass('d-inline')
          $('.last').html(
            "<img src='/static/images/right_arrow.svg'><img src='/static/images/right_arrow.svg'>")
        }
      })
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Datatable.vue